// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "2026-08-11_08_20_38/static/js/" + chunkId + "." + {"419":"66d8ab85","453":"4d71847c"}[chunkId] + ".chunk.js";
};